// MfaAuthSelectPanel.js
import React, { useState, useEffect, useRef } from 'react';
import styles from '../../MfaPage.module.css'; 
import axios from "../../../../utils/api/axios";
import { IAM_MFA_OTP } from '../../../../utils/Config';
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';

function MfaOtpVerifyPanel({ onSuccess, onBack, userId }) {
    const { showDialog } = useDialog();
    const [code, setCode] = useState(new Array(6).fill(''));
    const [isSubmitting, setIsSubmitting] = useState(false);
    const inputRefs = useRef([]);
    const confirmButtonRef = useRef(null); 

    const handleCodeChange = (e, index) => {
        const { value } = e.target;
        const newCode = [...code];
        if (value.length > 1) {
            newCode[index] = value[0];
        } else {
            newCode[index] = value;
        }
        setCode(newCode);

        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        } else if (value && index === 5) {
            // 마지막 input 입력 완료 시 확인 버튼으로 포커스 이동
            setTimeout(() => {
                confirmButtonRef.current?.focus();
            }, 0);
        }
    };
    
    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text').trim();
        if (pasteData.length === 6 && /^[0-9]+$/.test(pasteData)) {
            const newCode = pasteData.split('');
            setCode(newCode);
            // 6자리 입력 완료 시 확인 버튼으로 포커스 이동
            setTimeout(() => {
                confirmButtonRef.current?.focus();
            }, 0);
        }
    };
    
    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !e.target.value && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleConfirm = async () => {
        const otpCode = code.join('');
        if (otpCode.length !== 6) {
            showDialog({
                iconType: "info",
                type: 'info',
                title: "알림",
                message: "인증번호 6자리를 모두 입력해주세요.",
                confirmText: "확인",
            }); 
            return;
        }

        setIsSubmitting(true); 

        try {
            const url = `${IAM_MFA_OTP}/verify`;
            const payload = { unifiedProfileId: userId, code: otpCode };
            const res = await axios.post(url, payload);

            if (res.data.data.verified) {
                onSuccess();
            } else {
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "알림",
                    message: "인증번호가 일치하지 않습니다.",
                    confirmText: "확인",
                }); 
            }
        } catch (err) {
            console.error("OTP 인증 오류:", err);
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "알림",
                message: "인증 중 오류가 발생했습니다.",
                confirmText: "확인",
            }); 
        } finally {
            setIsSubmitting(false);
        }
    };

    const isButtonDisabled = code.join('').length !== 6 || isSubmitting;

    return (
        <div className={styles.section_wrapper}>
            <div className={styles.section_header_wrapper}>
                <div className={styles.header_text}>OTP 인증번호를 <br className={styles.mobile_only}/> 입력해주세요.</div>
            </div>
            <div className={styles.email_verify_code_wrapper}>
                <div className={styles.email_verify_code_row_wrapper}>
                    <div className={styles.email_verify_code_row}>
                        {code.map((char, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength={1}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className={styles.email_verify_code_box}
                                value={char}
                                onChange={(e) => handleCodeChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                onPaste={handlePaste}
                                ref={el => inputRefs.current[index] = el}
                            />
                        ))}
                    </div> 
                </div>
                <div className={styles.submit_btn_container}>
                    <InnocodeButton
                       id="btn-otp-confirm"
                        size='lg'
                        onClick={handleConfirm}
                        disabled={isButtonDisabled}
                        className={styles.submit_btn}
                        ref={confirmButtonRef}
                    >
                        확인
                    </InnocodeButton>
                    <InnocodeButton
                        size='lg'
                        designType='assistive'
                        theme='line'
                        onClick={onBack}
                        className={styles.submit_btn}
                    >
                        다른 수단으로 인증하기
                    </InnocodeButton>
                    
                    {/* <button
                        id="btn-otp-confirm"
                        className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.submit_btn} ${isButtonDisabled ? styles.disabled : ''}`}
                        onClick={handleConfirm}
                        disabled={isButtonDisabled}
                    >
                        <span className={components.btn__text}>확인</span>
                    </button>
                    <button
                        id="link-otp-back"
                        className={`${components.link_btn} ${components.link_btn_assistive}`}
                        onClick={onBack}
                    >
                        다른 수단으로 인증하기
                    </button> */}
                </div>
            </div>
        </div>
    );
}

export default MfaOtpVerifyPanel;